import { render, staticRenderFns } from "./_TaskItem.vue?vue&type=template&id=3e4cee36&scoped=true"
import script from "./_TaskItem.vue?vue&type=script&lang=ts"
export * from "./_TaskItem.vue?vue&type=script&lang=ts"
import style0 from "./_TaskItem.vue?vue&type=style&index=0&id=3e4cee36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4cee36",
  null
  
)

export default component.exports